import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import PageCompLoader from '@/components/loaders/PageCompLoader'
import { AZURE_CONSENT_URL } from '@/constants/allconstants'
const ConsentScreen = () => {
    const [queryParams, setQueryParams] = useSearchParams()

    useEffect(() => {
        // Retrieve the 'domain' query parameter from the URL using queryParams
        const domain = queryParams.get('domain');
    
        // Retrieve the 'token' query parameter from the URL using queryParams
        const token = queryParams.get('token');
    
        // Redirect the user to the Azure consent URL, passing the domain and user type ('admin') as parameters
        window.location.href = AZURE_CONSENT_URL(domain, `admin,${token}`);
    }, []);

    return (
        <PageCompLoader />
    )
}

export default ConsentScreen